import { render, staticRenderFns } from "./xlsx.vue?vue&type=template&id=56490082&"
import script from "./xlsx.vue?vue&type=script&lang=js&"
export * from "./xlsx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56490082')) {
      api.createRecord('56490082', component.options)
    } else {
      api.reload('56490082', component.options)
    }
    module.hot.accept("./xlsx.vue?vue&type=template&id=56490082&", function () {
      api.rerender('56490082', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/plugins/import/xlsx.vue"
export default component.exports